import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@lib/i18n';
import '@styles/theme.css';
import { AppProviders } from '@app/providers';
import { AppRouter } from '@app/router';

// Defense-in-depth for stale-chunk failures (also handled in RouteErrorBoundary):
// Vite fires `vite:preloadError` when a <link modulepreload> for a dynamic chunk
// 404s after a redeploy. Reload once to fetch the fresh HTML + matching hashes;
// the sessionStorage guard (same key as RouteErrorBoundary) prevents a loop.
window.addEventListener('vite:preloadError', () => {
  try {
    const KEY = 'chunk-reload-ts';
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Number.isFinite(last) && Date.now() - last <= 10_000) return;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* private mode / quota — reload anyway */
  }
  window.location.reload();
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
